<template>
	<div class="popup row">
		<p class="column">{{message}}</p>
	</div>
</template>

<script>
	export default {
		props: ['message']
	}
</script>